// extracted by mini-css-extract-plugin
module.exports = {"timelineItem":"styles_timelineItem__UQWH5","content":"styles_content__82Yi_"};